import { axiosJSONInstance, axiosMultipartInstance } from '@/config';
import {
  ClaimDetailResponse,
  ClaimEligibilityResponse,
  ClaimListResponse,
} from '@/types';

// Check claim eligibility for a specific order
export const fetchClaimEligibility = async (
  orderUid: string,
): Promise<ClaimEligibilityResponse> => {
  const response = await axiosJSONInstance.get(
    `/merchants/orders/${orderUid}/claim-eligibility`,
  );
  return response.data;
};

// File a new claim for a specific order (multipart — supports evidence attachments)
export const fileClaim = async (
  orderUid: string,
  formData: FormData,
): Promise<ClaimDetailResponse> => {
  const response = await axiosMultipartInstance.post(
    `/merchants/orders/${orderUid}/claim`,
    formData,
  );
  return response.data;
};

// Fetch paginated claims list with optional status/type filters
export const fetchClaims = async (
  page: number,
  perPage: number,
  status?: string,
  type?: string,
): Promise<ClaimListResponse> => {
  const params = new URLSearchParams({
    page: page.toString(),
    per_page: perPage.toString(),
  });

  if (status) params.append('status', status);
  if (type) params.append('type', type);

  const response = await axiosJSONInstance.get(`/merchants/claims?${params.toString()}`);
  return response.data;
};

// Fetch a single claim by its UID
export const fetchClaimByUid = async (uid: string): Promise<ClaimDetailResponse> => {
  const response = await axiosJSONInstance.get(`/merchants/claims/${uid}`);
  return response.data;
};
